import { KYBTestcacheActionTypes, apiActionsKYBTestcache } from "./SupportActionConstants";
import authService from "../../auth/AuthService";

const updateKYBTestcacheFilter = () => ({
    type: KYBTestcacheActionTypes.FILTER_KYB_TESTCACHE_RECORDS
});

const setKYBTestcacheFilter = (filterOption, filterType) => ({
    type: KYBTestcacheActionTypes.SET_KYB_TESTCACHE_FILTER,
    payload: { filterOption, filterType }
});

const selectAllKYBTestcacheRecords = (recordIds, isSelected) => ({
    type: KYBTestcacheActionTypes.ALL_KYB_TESTCACHE_SELECTED,
    payload: { recordIds, isSelected },
});

const selectSomeKYBTestcacheRecords = (recordId, isSelected) => ({
    type: KYBTestcacheActionTypes.SOME_KYB_TESTCACHE_SELECTED,
    payload: { recordId, isSelected }
});

const toggleAddKYBTestcacheModal = () => ({
    type: KYBTestcacheActionTypes.TOGGLE_ADD_KYB_TESTCACHE_MODAL
});

const toggleEditKYBTestcacheModal = () => ({
    type: KYBTestcacheActionTypes.TOGGLE_EDIT_KYB_TESTCACHE_MODAL
});

const openEditKYBTestcacheModal = (kybTestcacheRecord) => ({
    type: KYBTestcacheActionTypes.OPEN_EDIT_KYB_TESTCACHE_MODAL,
    payload: kybTestcacheRecord
});

const setKYBTestcacheForm = ({ name, value }) => ({
    type: KYBTestcacheActionTypes.SETTING_KYB_TESTCACHE_FORM_OBJECT_VALUE,
    payload: { name, value },
});

const setSourcesForKYBTestcache = (sourceTypes) => ({
    type: KYBTestcacheActionTypes.LOAD_KYB_SOURCE_TYPES,
    payload: sourceTypes,
});

const setKYBTestcacheCountryValue = ({ country }) => ({
    type: KYBTestcacheActionTypes.SET_KYB_COUNTRY,
    payload: { country }
});

const setKYBTestcacheSourceTypeValue = ({ datasource }) => ({
    type: KYBTestcacheActionTypes.SET_KYB_SOURCE_TYPE,
    payload: { datasource }
});

const generateKYBPostmanRequest = () => ({
    type: KYBTestcacheActionTypes.GENERATE_KYB_POSTMAN_REQUEST,
});

// API Action Constants for KYB Testcache
const getKYBTestcacheData = (authToken) => ({
    type: apiActionsKYBTestcache.GET_ALL_KYB_TESTCACHE,
    payload: { authToken }
});

const setKYBTestcacheData = (kybTestcacheData) => ({
    type: apiActionsKYBTestcache.SET_KYB_TESTCACHE_TABLE_DATA,
    payload: kybTestcacheData
});

const addNewKYBTestcacheRecord = (authToken, kybTestcacheObject) => ({
    type: apiActionsKYBTestcache.ADD_TO_KYB_TESTCACHE,
    payload: { authToken, kybTestcacheObject }
});

const editCurrentKYBTestcacheRecord = (authToken, kybTestcacheObject, kybTestcacheId) => ({
    type: apiActionsKYBTestcache.EDIT_KYB_TESTCACHE,
    payload: { authToken, kybTestcacheObject, kybTestcacheId }
});

const deleteCurrentKYBTestcacheRecord = (authToken, kybTestcacheId) => ({
    type: apiActionsKYBTestcache.DELETE_KYB_TESTCACHE,
    payload: { authToken, kybTestcacheId }
});

const deleteWarningForKYBTestcacheRecord = (kybTestcacheId) => ({
    type: apiActionsKYBTestcache.DELETE_WARNING_FOR_KYB_TESTCACHE,
    payload: kybTestcacheId
});

const unmountKYBTestcacheDetails = () => ({
    type: KYBTestcacheActionTypes.CLEAR_KYB_TESTCACHE_DETAILS
});


/**
 * ACTION TO CLEAR THE KYB TESTCACHE DETAILS FROM REDUX STORE
 */
export function unmountKYBTestcache() {
    return (dispatch) => {
        dispatch(unmountKYBTestcacheDetails());
    }
}

/**
 * ACTION TO GET THE KYB TESTCACHE TABLE DATA
 */
export function fetchKYBTestcacheTableData() {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(getKYBTestcacheData(authToken));
    }
}

/**
 * ACTION TO SET THE KYB TESTCACHE DATA FOR LIST PAGE.
 */
export function kybTestcacheTableDataSuccess(kybTestcacheData) {
    return (dispatch) => {
        dispatch(setKYBTestcacheData(kybTestcacheData));
    }
}

/**
 * ACTION TO SET THE KYB TESTCACHE FILTER VALUE.
 */
export function setKYBTestcacheRecordsFilter(filterOption, filterType) {
    return (dispatch) => {
        dispatch(setKYBTestcacheFilter(filterOption, filterType));
    }
}

/**
 * ACTION TO FILTER THE KYB RECORDS BASED ON CURRENT FILTER VALUES.
 */
export function updateKYBTestcacheFilters() {
    return (dispatch) => {
        dispatch(updateKYBTestcacheFilter())
    };
}

export function selectAllKYBTestcache(recordIds, isSelected) {
    return (dispatch) => {
        dispatch(selectAllKYBTestcacheRecords(recordIds, isSelected))
    }
}

export function selectSomeKYBTestcache(recordId, isSelected) {
    return (dispatch) => {
        dispatch(selectSomeKYBTestcacheRecords(recordId, isSelected))
    }
}

export function generateKYBPostmanReq() {
    return (dispatch) => {
        dispatch(generateKYBPostmanRequest())
    }
}

export function toggleAddKYBTestcacheRecordsModal() {
    return (dispatch) => {
        dispatch(toggleAddKYBTestcacheModal())
    }
}

export function openEditKYBTestcacheRecordsModal(kybTestcacheRecord) {
    return (dispatch) => {
        dispatch(openEditKYBTestcacheModal(kybTestcacheRecord))
    }
}

export function toggleDeleteKYBTestcacheRecordsModal(kybTestcacheId) {
    return (dispatch) => {
        dispatch(deleteWarningForKYBTestcacheRecord(kybTestcacheId))
    }
}

export function toggleEditKYBTestcacheRecordsModal() {
    return (dispatch) => {
        dispatch(toggleEditKYBTestcacheModal())
    }
}

export function setKYBTestcacheFormValues({ name, value }) {
    return (dispatch) => {
        dispatch(setKYBTestcacheForm({ name, value }));
    }
}

export function loadSourcesForKYBTestcache(sourceTypes) {
    return (dispatch) => {
        dispatch(setSourcesForKYBTestcache(sourceTypes))
    }
}

export function addKYBTestcacheRecord(kybTestcacheObject) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(addNewKYBTestcacheRecord(authToken, kybTestcacheObject))
    }
}

export function editKYBTestcacheRecord(kybTestcacheObject, kybTestcacheId) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(editCurrentKYBTestcacheRecord(authToken, kybTestcacheObject, kybTestcacheId))
    }
}

export function deleteKYBTestcacheRecord(kybTestcacheId) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(deleteCurrentKYBTestcacheRecord(authToken, kybTestcacheId))
    }
}

export function setKYBTestcacheCountry({ country }) {
    return (dispatch) => {
        dispatch(setKYBTestcacheCountryValue({ country }));
    }
}

export function setKYBTestcacheSourceType({ datasource }) {
    return (dispatch) => {
        dispatch(setKYBTestcacheSourceTypeValue({ datasource }));
    }
}

const exports = {
    apiActionsKYBTestcache,
    KYBTestcacheActionTypes,
}

export default exports;

